import { render, staticRenderFns } from "./CentralAlerta.vue?vue&type=template&id=7b52590d&scoped=true&lang=pug"
import script from "./CentralAlerta.vue?vue&type=script&lang=js"
export * from "./CentralAlerta.vue?vue&type=script&lang=js"
import style0 from "./CentralAlerta.vue?vue&type=style&index=0&id=7b52590d&prod&lang=scss&scoped=true"
import style1 from "./CentralAlerta.vue?vue&type=style&index=1&id=7b52590d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52590d",
  null
  
)

export default component.exports